export default "__VITE_ASSET__C6S0pSiy__"